import esMX from './es-MX';

export const byLanguageCode = {
  "es-MX": esMX,
};

export default byLanguageCode;
